import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';

export class AccountRoleAndPrivilegesDataProvider extends BaseWebComponentDataProvider {
  async getAvailableRolesForCompany(companyId): Promise<any> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'Roles',
      method: 'getAvailableRolesForCompany',
      payload: {
        page: 1, // there are max 5 items at the moment
        companyId: companyId,
      },
    });
  }
}
